export default __webpack_public_path__ + "static/media/andean3.733fb134.jpg";